var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.images && _vm.images.length)?_c('div',{staticClass:"columns"},_vm._l((_vm.images),function(image){return _c('div',{key:image.image,staticClass:"column"},[_c('image-preview',{attrs:{"image":image,"blindMode":_vm.project.blindMode}})],1)}),0):_c('div',[_vm._v(" "+_vm._s(_vm.$t('no-image-recently-opened'))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }